<template>
  <div class="submitSuccess">
    <div class="submitSuccess_img">
      <img src="../assets/image/success.png" alt />
    </div>
    <div class="submitSuccess_text">
      <p>{{$t('promote.success1')}}</p>
      <span>{{$t('promote.success2')}}</span>
      <label>{{$t('promote.success3')}}</label>
      <label>092-6862875、 062-5626123</label>
      <!--<label>0876711903、0618971398、0634711604</label>-->
    </div>
  </div>
</template>
<script>
import { mapMutations } from "vuex";
export default {
  components: {},
  data() {
    return {};
  },
  computed: {
    lang() {
      return this.$store.state.lang;
    }
  },
  created() {
   setTimeout("history.go(-1)",3000) ;
  },
  methods: {
    ...mapMutations({
      get_lang: "get_lang"
    })
  }
};
</script>
<style lang='less'>
@media (min-device-width: 300px) {
  .submitSuccess {
    width: 100%;
    height: auto;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 60px 0;
    .submitSuccess_img {
      width: 70%;
      img {
        width: 100%;
      }
    }
    .submitSuccess_text {
      display: flex;
      flex-direction: column;
      align-items: center;
      span {
        font-size: 18px;
        color: #888888;
        margin-bottom: 40px;
        display: block;
      }
      label {
        font-size: 18px;
        color: #666;
        margin-bottom: 10px;
        display: block;
      }
      p {
        font-size: 30px;
        color: #ff6430;
        font-weight: 600;
        margin: 22px 0;
      }
    }
  }
}
@media (min-device-width: 120px) {
  .submitSuccess {
    width: 100%;
    height: auto;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 60px 0;
    .submitSuccess_img {
      width: 40%;
      img {
        width: 100%;
      }
    }
    .submitSuccess_text {
      display: flex;
      flex-direction: column;
      align-items: center;
      span {
        font-size: 18px;
        color: #888888;
        margin-bottom: 40px;
        display: block;
      }
      label {
        font-size: 18px;
        color: #666;
        margin-bottom: 10px;
        display: block;
      }
      p {
        font-size: 30px;
        color: #ff6430;
        font-weight: 600;
        margin: 22px 0;
      }
    }
  }
}
</style>